/**
 * Prefix an in-app path with the build's base path, for the links that are plain
 * `<a href>` rather than react-router `<Link>`.
 *
 * React Router's basename only covers `<Link>`/`navigate()`. A raw
 * `<a href="/onboarding">` resolves against the ORIGIN, so on a path-prefixed
 * deployment (staging ships `--base=/staging/web/`) it leaves the app entirely
 * and 404s — which is how the diagnostic's "Start free for 7 days" CTA, the Pass
 * Plan download and the exam-report link were all dead ends on staging.
 *
 * BASE_URL is "/" for the production build, so this returns the path unchanged
 * there. Only absolute in-app paths are rewritten; anything else is passed
 * through untouched.
 */
export function appHref(path: string): string {
  if (!path.startsWith('/')) return path;
  const base = (import.meta.env.BASE_URL ?? '/').replace(/\/+$/, '');
  return `${base}${path}`;
}
